module.exports = __webpack_public_path__ + "c9b72aff693c21d17fe1310ec62ade44.jpg";